// const API_URL = "http://10.182.246.119:5556/";
// const API_URL = "http://192.168.1.55:5556/";
// const API_URL = "http://localhost:5000/api/";

const API_URL = "/api/";

export const api_url = (tail) => {
  return `${API_URL}${tail}`;
}

const get = (url) => {
  const promise = new Promise((resolve, reject) => {
    fetch(api_url(url), {
      method: "GET"
    }).then((response) => {
      if (response.ok) {
          response.json()
          .then(data => resolve(data))
          .catch(reject);
      }
      else {
        reject();
      }
    }).catch(reject);
  });

  return promise;
}


const _post = (url, data) => {
  const promise = new Promise((resolve, reject) => {
    const postData = new FormData();

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (Array.isArray(data[key])) {
          data[key].forEach((v) => postData.append(key, v));
        } else {
          postData.append(key, data[key]);
        }
      }
    }

    fetch(api_url(url), {
      method: "POST",
      body: postData
    }).then(resolve).catch(reject);
  });

  return promise;
}

// TODO generalize API call function
const post = (url, data) => {
  const promise = new Promise((resolve, reject) => {
    _post(url, data).then((response) => {
      if (response.ok) {
        response.json()
          .then((data) => resolve(data))
          .catch(reject);
      } else {
        reject();
      }
    }).catch(reject);
  });

  return promise;
}

export const suggest = (w1, w2) => post('suggest', { seed: [w1, w2] });

export const say = (txt, speed, pitch, volume) => {
  const promise = new Promise((resolve, reject) => {
    _post('say', { txt, speed, pitch, volume })
      .then((response) => {
        if (response.ok) {
          response.blob().then(resolve);
        } else {
          reject();
        }
      }).catch(reject);
  });
  
  return promise;
}

export const start_token = () => get('start_token')

export const get_texts = () => get('texts')

export const update_texts = (texts) => post('update_texts', { texts })


// WEBPACK FOOTER //
// ./src/services/api.js